import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const pmApi = {
  // Projects + epics
  workspaces: () => api.get('/projects/workspaces').then(unwrap),
  createWorkspace: (payload) => api.post('/projects/workspaces', payload).then(unwrap),
  projects: (params) => api.get('/projects', { params }).then(unwrap),
  getProject: (idOrKey) => api.get(`/projects/${idOrKey}`).then(unwrap),
  createProject: (payload) => api.post('/projects', payload).then(unwrap),
  epics: (projectId) => api.get(`/projects/${projectId}/epics`).then(unwrap),
  createEpic: (projectId, payload) => api.post(`/projects/${projectId}/epics`, payload).then(unwrap),

  // Issues
  issues: (params) => api.get('/issues', { params }).then(unwrap),
  getIssue: (id) => api.get(`/issues/${id}`).then(unwrap),
  getIssueByKey: (key) => api.get(`/issues/by-key/${key}`).then(unwrap),
  createIssue: (payload) => api.post('/issues', payload).then(unwrap),
  updateIssue: (id, patch) => api.patch(`/issues/${id}`, patch).then(unwrap),
  setIssueStatus: (id, status, rank) => api.put(`/issues/${id}/status`, { status, rank }).then(unwrap),
  deleteIssue: (id) => api.delete(`/issues/${id}`).then(unwrap),
  comments: (id) => api.get(`/issues/${id}/comments`).then(unwrap),
  addComment: (id, body, mentions) => api.post(`/issues/${id}/comments`, { body, mentions }).then(unwrap),
  worklogs: (id) => api.get(`/issues/${id}/worklogs`).then(unwrap),
  addWorklog: (id, payload) => api.post(`/issues/${id}/worklogs`, payload).then(unwrap),
  dependencies: (id) => api.get(`/issues/${id}/dependencies`).then(unwrap),
  addDependency: (id, payload) => api.post(`/issues/${id}/dependencies`, payload).then(unwrap),
  removeDependency: (id, depId) => api.delete(`/issues/${id}/dependencies/${depId}`).then(unwrap),
  traceability: (id) => api.get(`/issues/${id}/traceability`).then(unwrap),

  // Boards & sprints
  boards: (projectId) => api.get('/boards', { params: { project_id: projectId } }).then(unwrap),
  getBoard: (id, sprintId) => api.get(`/boards/${id}`, { params: sprintId ? { sprint_id: sprintId } : {} }).then(unwrap),
  sprints: (projectId, status) => api.get('/sprints', { params: { project_id: projectId, status } }).then(unwrap),
  getSprint: (id) => api.get(`/sprints/${id}`).then(unwrap),
  createSprint: (payload) => api.post('/sprints', payload).then(unwrap),
  startSprint: (id) => api.post(`/sprints/${id}/start`).then(unwrap),
  completeSprint: (id) => api.post(`/sprints/${id}/complete`).then(unwrap),
  addToSprint: (id, issueIds) => api.post(`/sprints/${id}/issues`, { issueIds }).then(unwrap),
  removeFromSprint: (id, issueId) => api.delete(`/sprints/${id}/issues/${issueId}`).then(unwrap),

  // QA
  testSuites: (projectId) => api.get('/qa/suites', { params: { project_id: projectId } }).then(unwrap),
  createTestSuite: (payload) => api.post('/qa/suites', payload).then(unwrap),
  testCases: (suiteId) => api.get('/qa/cases', { params: { suite_id: suiteId } }).then(unwrap),
  createTestCase: (payload) => api.post('/qa/cases', payload).then(unwrap),
  testPlans: (projectId) => api.get('/qa/plans', { params: { project_id: projectId } }).then(unwrap),
  getTestPlan: (id) => api.get(`/qa/plans/${id}`).then(unwrap),
  createTestPlan: (payload) => api.post('/qa/plans', payload).then(unwrap),
  addCasesToPlan: (id, payload) => api.post(`/qa/plans/${id}/cases`, payload).then(unwrap),
  testExecutions: (params) => api.get('/qa/executions', { params }).then(unwrap),
  executeTest: (payload) => api.post('/qa/executions', payload).then(unwrap),
  defects: (params) => api.get('/qa/defects', { params }).then(unwrap),
  createDefect: (payload) => api.post('/qa/defects', payload).then(unwrap),
  updateDefect: (id, patch) => api.patch(`/qa/defects/${id}`, patch).then(unwrap),
  qaMetrics: (projectId) => api.get('/qa/metrics', { params: { project_id: projectId } }).then(unwrap),

  // Releases & deployments
  releases: (projectId) => api.get('/releases', { params: { project_id: projectId } }).then(unwrap),
  getRelease: (id) => api.get(`/releases/${id}`).then(unwrap),
  releaseReadiness: (id) => api.get(`/releases/${id}/readiness`).then(unwrap),
  createRelease: (payload) => api.post('/releases', payload).then(unwrap),
  deployments: (releaseId) => api.get(`/releases/${releaseId}/deployments`).then(unwrap),
  deploy: (releaseId, payload) => api.post(`/releases/${releaseId}/deployments`, payload).then(unwrap),
  completeDeployment: (id, payload) => api.post(`/releases/deployments/${id}/complete`, payload).then(unwrap),
  recordCommit: (payload) => api.post('/releases/commits', payload).then(unwrap),
  commits: (params) => api.get('/releases/commits/list', { params }).then(unwrap),
};
